/**
 * External dependencies
 */
import React, { useState } from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const Search = (props) => {
	const [hasFocus, setHasFocus] = useState(false);
	const [keyWord, setKeyWord] = useState(props.initialValue);

	const searchClasses = classNames('search', {
		'has-focus': hasFocus,
	});

	const onChange = (e) => {
		setKeyWord(e.target.value);
		props.onChange(e.target.value);
	};

	const onBlur = (e) => {
		if (props.onBlur) {
			props.onBlur(e);
		}
		setHasFocus(false);
	};

	const onFocus = (e) => {
		if (props.onFocus) {
			props.onFocus(e);
		}
		setHasFocus(true);
	};

	return (
		<div className={searchClasses} role='search'>
			<div role='button' className='search__icon-navigation'>
				<Icon name='FiSearch' className='search__open-icon' size={20} />
			</div>
			<div className='search__input-fade'>
				<input
					className='search__input'
					type='search'
					value={keyWord}
					onChange={onChange}
					onFocus={onFocus}
					onBlur={onBlur}
					placeholder={props.placeholder}
				/>
			</div>
		</div>
	);
};

Search.defaultProps = {
	placeholder: 'Search…',
};

Search.propTypes = {};

export default Search;
